import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  // private apiUrl = "http://localhost:3003/api";
  private apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  addOrder(data:any){
    return this.http.post(this.apiUrl+'/addOrder',data);
  }
  getOrder(){
    return this.http.get(this.apiUrl+'/orderList');
  }
  getOrderById(id: string) {
    return this.http.get(this.apiUrl + '/order/' + id);
  }
 
  updateOrder(id: string, data: any) {
    return this.http.put(this.apiUrl + '/updateOrder/' + id, data);
  }


  getHighestTicketNumber(){
    return this.http.get(`${this.apiUrl}/highestTicketNumber/`);
  }


  confirmOrder(orderId: string, confirmationData: any) {
    return this.http.put(this.apiUrl + '/confirmOrder/' + orderId,confirmationData);
  }

  getConfirmedOrders() {
    return this.http.get(this.apiUrl + '/confirmedOrders');
  }

  // Method to delete multiple clients by IDs
  deleteAllOrder(ids: string[]) {
    return this.http.delete<any>(this.apiUrl + '/deleteSalesAllOrder', { body: { ids } });
  }

  getOrderCount(){
    return this.http.get(this.apiUrl+'/getOrderCount');
  }
  getConfirmOrders(page:any, limit:any, data:any) {
    return this.http.post(`${this.apiUrl}/getConfirmOrders?page=`+page+`&limit=`+limit,data);
  }
  getExportConfirmOrders(data:any) {
    return this.http.post(`${this.apiUrl}/exportConfirmOrders`,data);
  }

}